<template>
  <div class="row m-0">
    <div class="col-12 h-10 bg pt-5 pb-5">
    </div>
    <div class="col-12 mt-4">
      <div class="row m-0">
        <div class="col-12 grey">
          Please select the 3 icons you see on your scratch card from below list
        </div>
      </div>
      <div class="row m-0 align-items-center justify-content-around pt-3">
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="1"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="2"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="3"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="4"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="5"></selections>
      </div>
      <div class="row m-0 align-items-center justify-content-around pt-3">
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="6"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="7"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="8"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="9"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="10"></selections>
      </div>
      <div class="row m-0 align-items-center justify-content-around pt-3">
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="11"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="12"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="13"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="14"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="15"></selections>
      </div>
      <div class="row m-0 align-items-center justify-content-around pt-3">
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="16"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="17"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="18"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="19"></selections>
        <selections :showMessage.sync="showMessage" :selectedIcons.sync="selectedIcons" image="20"></selections>
      </div>
    </div>
    <div class="row justify-content-end abs">
      <div class="col-8">
        <div class="row m-0">
          <div class="col-12 text-right text-red" v-if="showMessage">
            Incorrect Unique Code Icon Combo
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="row m-0">
          <div class="col-12 text-right">
            <button :disabled="!canProceed" @click="submit()" class="btn btn-gradient pl-5 pr-5">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Selections from './partials/Selections.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Select',
  components: {
    'selections': Selections
  },
  computed: {
    ...mapGetters([
      'codeCombos',
      'code'
    ]),
    canProceed () {
      return this.selectedIcons.length === 3
    }
  },
  data () {
    return {
      selectedIcons: [],
      showMessage: false
    }
  },
  mounted () {
    if (typeof this.codeCombos[this.code] === 'undefined') {
      this.$router.push('/')
    }
  },
  methods: {
    ...mapActions([
      'setIcons'
    ]),
    submit () {
      console.log('here')
      if (this.selectedIcons.indexOf(this.codeCombos[this.code].image1) !== -1 && this.selectedIcons.indexOf(this.codeCombos[this.code].image2) !== -1 && this.selectedIcons.indexOf(this.codeCombos[this.code].image3) !== -1) {
        console.log('true')
        this.setIcons(this.selectedIcons)
        this.$router.push('/intro')
      } else {
        this.showMessage = true
        console.log('false')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  background: -webkit-linear-gradient(0deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 100%);
}
.h-10 {
  height: 10vh;
}
.grey {
  color: grey;
}
.abs {
  position: absolute;
  bottom: 3vh;
  width: 100%;
}
.btn-gradient {
  background: -webkit-linear-gradient(0deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 95%);
  border-radius: 0;
  border: none;
  color: #fff;
}
.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Select.vue